<div *ngIf="showTabs" style="display: flex; flex-direction: column">
  <opac-skeleton class="hide-desktop" style="width: 249px; height: 20px; margin-bottom: 32px"></opac-skeleton>

  <div class="selected-tab"></div>
  <div class="tabs">
    <opac-skeleton class="first-tab"></opac-skeleton>
    <opac-skeleton class="second-tab"></opac-skeleton>
  </div>
  <opac-skeleton class="separator"></opac-skeleton>
</div>

<section *ngFor="let i of [1, 2]; let first = first" [style.margin-top]="!showTabs && first ? '0px' : '40px'">
  <div style="display: flex; gap: 12px; flex-direction: column;">
    <opac-skeleton style="width: 249px; height: 20px"></opac-skeleton>
    <opac-skeleton style="width: 120px; height: 14px"></opac-skeleton>
  </div>

  <div class="fake-list">
    <div class="fake-item" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]">
      <opac-skeleton class="fake-cover"></opac-skeleton>
      <opac-skeleton class="fake-title"></opac-skeleton>
      <opac-skeleton class="fake-subtitle"></opac-skeleton>
    </div>
  </div>
</section>
